import { render, staticRenderFns } from "./DelfiLoader.vue?vue&type=template&id=144e97b3"
import script from "./DelfiLoader.vue?vue&type=script&lang=ts"
export * from "./DelfiLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports